import { APIHandler, EventSourceHandler } from "../base";
import { CreateRoomProps } from "../../common/interfaces/chats/create-room.interface";
import { AddQuestionProps } from "../../common/interfaces/chats/add-question.interface";
import { SummaryProps } from "../../common/interfaces/chats/summary.interface";
import { FeedbackProps } from "../../common/interfaces/chats/feedback.interface";

export const fetchRooms = (userId: string, kbUid: string) =>
    APIHandler.get(`/chats/${userId}/rooms/${kbUid}?pageSize=100&sortBy=createdAt&sortOrder=desc`);

export const createRoom = (userId: string, roomData: CreateRoomProps) =>
    APIHandler.post(`/chats/${userId}/room`, roomData);

export const archiveRoom = (userId: string, roomId: string) =>
    APIHandler.put(`/chats/${userId}/rooms/${roomId}/archivate`);

export const archiveAllRooms = (userId: string) =>
    APIHandler.put(`/chats/${userId}/rooms/archivateAll`);

export const fetchChatHistory = (userId: string, roomId: string) =>
    APIHandler.get(`/chats/${userId}/${roomId}/history?pageSize=100`);

export const addQuestion = (userId: string, roomId: string, questionData: AddQuestionProps) =>
    APIHandler.post(`/chats/sse/${userId}/${roomId}/question`, questionData, {
        withCredentials: true
    });

export const createQuestion = (userId: string, roomId: string, questionData: AddQuestionProps) =>
    APIHandler.post(`/chats/${userId}/${roomId}/createQuestion`, questionData);

export const pushQuestionToQueue = (
    userId: string,
    roomId: string,
    questionData: AddQuestionProps
) =>
    APIHandler.post(`/chats/see/${userId}/${roomId}/pushQuestionToQueue`, questionData, {
        withCredentials: true
    });

export const summarizeVideo = (userId: string, roomId: string, summaryData: SummaryProps) =>
    APIHandler.post(`/chats/sse/${userId}/${roomId}/summarizeVideo`, summaryData);

export const listenAnswers = (userId: string, roomId: string, typedEvents = false) =>
    EventSourceHandler(
        `/chats/sse/${userId}/${roomId}/answers${typedEvents ? "?events=typed" : ""}`
    );

export const feedback = (userId: string, roomId: string, feedbackData: FeedbackProps) =>
    APIHandler.post(`/chats/${userId}/${roomId}/feedback`, feedbackData);

export const resolveChatPresignedUrl = (
    userId: string,
    messageId: string | number,
    data: { bucket: string; bucketFilePath: string; s3Service?: string }
) => APIHandler.post(`/chats/${userId}/messages/${messageId}/presignedUrl`, data);

// Sheet excerpt viewer (spreadsheet citations design §4.2): windowed rows of
// a cited sheet, validated against the caller's message citations.
export const resolveSheetExcerpt = (
    userId: string,
    messageId: string | number,
    data: { recognitionResultId: string; sheetName: string; rowStart: number; rowEnd: number }
) => APIHandler.post(`/chats/${userId}/messages/${messageId}/sheetExcerpt`, data);
